import { render, staticRenderFns } from "./dynamicTable.vue?vue&type=template&id=f14f3a90"
import script from "./dynamicTable.vue?vue&type=script&lang=js"
export * from "./dynamicTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dynamicTable.vue"
export default component.exports